import React from 'react';
import {useTheme} from '@mui/material';
import type {FilledIconProps} from './types';
import {CheckRoundBackgroundIcon} from './CheckRoundBackgroundIcon';

export const VerifiedUncheckedIcon: React.FC<FilledIconProps> = ({
  fillColorCode,
  ...props
}) => {
  const {colors} = useTheme();
  return (
    <CheckRoundBackgroundIcon
      fillColorCode={fillColorCode ?? colors.warning}
      {...props}
    />
  );
};
